// @ngInject
function updateOrderNoteDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(orderId, note, orderNumberExternal) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'updateOrderNoteDialogController as vm',
            templateUrl: 'services/dialogs/updateOrderNoteDialog/updateOrderNoteDialog.tpl.html',
            size: 'md'
        };

        modalDefaults.resolve = {
            orderId: function() {
                return orderId;
            },
            note: function() {
                return note;
            },
            orderNumberExternal: function() {
                return orderNumberExternal;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function updateOrderNoteDialogController($uibModalInstance, OrdersApiService, orderId, note, orderNumberExternal, loadSpinnerService,  $sce) {
    var vm = this;

    vm.orderId = orderId;
    vm.note = note;
    vm.orderNumberExternal = orderNumberExternal;

    vm.closeModal = closeModal;
    vm.save = save;

    function closeModal(success, orderId, note, orderNumberExternal) {
        $uibModalInstance.close(success, orderId, note, orderNumberExternal);
    }

    function save() {
        loadSpinnerService.start('mainSpinner');
        if (vm.orderId === undefined || vm.orderId === null) { console.log('Order must be saved before updating order note.'); }
        if (vm.note === undefined || vm.note === null) { vm.note = ''; }
        if (vm.orderNumberExternal === undefined || vm.orderNumberExternal === null) { vm.orderNumberExternal = ''; }
        OrdersApiService.updateOrderNote(vm.orderId, vm.note, vm.orderNumberExternal).then(function(response) {
            $uibModalInstance.close({ success:true, orderId: vm.orderId, note: vm.note, orderNumberExternal: vm.orderNumberExternal});
        }, function(error) {
            console.log(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }
}

angular
    .module('services.dialogs.updateOrderNoteDialog', [])
    .service('updateOrderNoteDialogService', updateOrderNoteDialogService)
    .controller('updateOrderNoteDialogController', updateOrderNoteDialogController);
